/**
 * CartPanel.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import ShoppingCart from './ShoppingCart';
import { useLanguage } from '../context/LanguageContext';
import './CartPanel.css';

const CartPanel = ({ isOpen, onClose }) => {
  const { t } = useLanguage();
  const cart = t.shop.cart;
  return (
    <>
      <div
        className={`cart-panel-overlay ${isOpen ? 'open' : ''}`}
        onClick={onClose}
      ></div>
      <div className={`cart-panel ${isOpen ? 'open' : ''}`}>
        <div className="cart-panel-header">
          <h2>{cart.yourCart}</h2>
          <button onClick={onClose} className="close-panel-btn" aria-label={cart.closeAria}>
            &times;
          </button>
        </div>
        {isOpen ? <ShoppingCart onClose={onClose} /> : null}
      </div>
    </>
  );
};

export default CartPanel; 